import Flip1 from "../Assets/flip1.png";
import Flip2 from "../Assets/flip2.png";
import Flip3 from "../Assets/flip3.png";
import Flip4 from "../Assets/flip4.png";
import Flip5 from "../Assets/flip5.png";

const FidusDifference = () => {
  return (
    <section id="section2">
      <div className="fidus-difference" id="thefidusdifference">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-6 col-lg-6 ps-0 pe-0 pe-lg-2">
              <div className="left">
                <div className="content">
                  <h2>
                    The <span>Fidus</span> Difference
                  </h2>
                  <p>
                    <strong>At Fidus</strong>, we specialize in creating
                    innovative,{" "}
                    <strong>high-quality e-learning solutions</strong> tailored
                    to meet the specific needs of a wide range of industries.
                    While our expertise spans across multiple sectors, we have a
                    particular focus on the <strong>Aviation industry</strong>,
                    where we deliver cutting edge training solutions that ensure{" "}
                    <strong>safety, compliance</strong>, and operational
                    efficiency.
                  </p>
                </div>
                <div className="icon">
                  <div className="circle">
                    <span>
                      <svg
                        width="48"
                        height="48"
                        viewBox="0 0 48 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M33.0204 19.8184L26.5532 10.2148L20.0859 19.8184H23.4079V44.7406H29.6984V19.8184H33.0204Z"
                          fill="#58DBDF"
                        />
                        <path
                          d="M47.7679 31.3131L41.3006 21.7096C41.0476 21.3337 40.6241 21.1086 40.1711 21.1086C39.7181 21.1086 39.2947 21.3337 39.0416 21.7096L32.5745 31.3131C32.2934 31.7305 32.2654 32.269 32.5019 32.7134C32.7384 33.1577 33.2007 33.4354 33.704 33.4354H35.6642V43.3795H31.0615V21.1805H33.0218C33.525 21.1805 33.9873 20.9029 34.2238 20.4585C34.4602 20.014 34.4323 19.4756 34.1512 19.0582L27.684 9.45459C27.431 9.07875 27.0075 8.85356 26.5545 8.85356C26.1015 8.85356 25.678 9.07875 25.425 9.45459L18.9578 19.0582C18.6768 19.4756 18.6488 20.0141 18.8853 20.4585C19.1218 20.9028 19.5841 21.1805 20.0873 21.1805H22.0476V43.3794H17.4449V37.5229H19.4051C20.157 37.5229 20.7668 36.9131 20.7668 36.1612C20.7668 35.4094 20.157 34.7996 19.4051 34.7996H16.0833C15.3314 34.7996 14.7217 35.4094 14.7217 36.1612V43.3794H11.1546V36.1612C11.1546 35.4094 10.5448 34.7996 9.79294 34.7996H9.02962L12.9382 28.9953L14.8255 31.7979C15.2457 32.4217 16.092 32.5866 16.7156 32.1668C17.3394 31.7467 17.5045 30.9005 17.0845 30.2767L14.0678 25.7971C13.8148 25.4212 13.3913 25.1961 12.9383 25.1961C12.4853 25.1961 12.0619 25.4212 11.8088 25.7971L5.34169 35.4008C5.06063 35.8183 5.03259 36.3568 5.26912 36.8012C5.50566 37.2455 5.96794 37.5232 6.47119 37.5232H8.43141V43.3797H2.72325V3.26006C2.72325 2.50819 2.1135 1.89844 1.36162 1.89844C0.60975 1.89844 0 2.50819 0 3.26006V44.7411C0 45.493 0.60975 46.1028 1.36162 46.1028H42.8427H43.3164C44.0683 46.1028 44.6781 45.493 44.6781 44.7411C44.6781 43.9893 44.0683 43.3795 43.3164 43.3795H42.8427H38.3874V32.0737C38.3874 31.3219 37.7777 30.7121 37.0258 30.7121H36.2625L40.1711 24.908L44.0798 30.7121H43.3165C42.5647 30.7121 41.9549 31.3219 41.9549 32.0737V39.3873C41.9549 40.1392 42.5647 40.7489 43.3165 40.7489C44.0684 40.7489 44.6782 40.1392 44.6782 39.3873V33.4354H46.6384C47.1416 33.4354 47.6039 33.1578 47.8404 32.7134C48.0768 32.269 48.0488 31.7305 47.7679 31.3131ZM24.771 43.3794V19.8188C24.771 19.067 24.1612 18.4572 23.4094 18.4572H22.6461L26.5547 12.6531L30.4634 18.4572H29.7C28.9481 18.4572 28.3384 19.067 28.3384 19.8188V43.3794H24.771Z"
                          fill="#007A96"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 pe-0 ps-0 ps-lg-2">
              <div className="right">
                <div className="images">
                  <div className="left-flex">
                    <img src={Flip3} className="left-flex1" width={175} alt="" />
                    <img src={Flip1} className="left-flex2" width={125} alt="" />
                  </div>
                  <div className="center-flex">
                    <img src={Flip4} className="center-flex1" width={125} alt="" />
                  </div>
                  <div className="right-flex">
                    <img src={Flip5} className="right-flex1" width={175} alt="" />
                    <img src={Flip2} className="right-flex2" width={100} alt="" />
                  </div>
                </div>
                <div className="icon">
                  <div className="circle">
                    <span>
                      <svg
                        width="48"
                        height="48"
                        viewBox="0 0 48 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_3594_29031)">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M24 0C28.2663 0 32.4762 1.152 36.1779 3.32895L34.7464 5.76283C31.4767 3.84 27.7609 2.8235 24 2.8235C12.3219 2.8235 2.82353 12.3219 2.82353 24C2.82353 35.6781 12.3219 45.1764 24 45.1764C35.6781 45.1764 45.1765 35.6781 45.1765 24C45.1765 20.2362 44.16 16.5205 42.2372 13.2508L44.6682 11.8221C46.848 15.5238 48 19.7336 48 24C48 37.2339 37.2339 48 24 48C10.7661 48 0 37.2339 0 24C0 10.7661 10.7661 0 24 0ZM24 8.4706V11.2941C16.9948 11.2941 11.2941 16.9948 11.2941 24C11.2941 31.0052 16.9948 36.7059 24 36.7059C31.0052 36.7059 36.7059 31.0052 36.7059 24H39.5294C39.5294 32.5638 32.561 39.5294 24 39.5294C15.4391 39.5294 8.4706 32.5638 8.4706 24C8.4706 15.4363 15.4391 8.4706 24 8.4706ZM24 16.9412V19.7647C21.6649 19.7647 19.7647 21.6649 19.7647 24C19.7647 26.3351 21.6649 28.2353 24 28.2353C26.3351 28.2353 28.2353 26.3351 28.2353 24H31.0588C31.0588 27.8908 27.8937 31.0588 24 31.0588C20.1063 31.0588 16.9412 27.8908 16.9412 24C16.9412 20.1092 20.1063 16.9412 24 16.9412ZM45.5853 0.411675L47.5844 2.40793L33.0536 16.9412H39.5294V19.7647H28.2353V8.4706H31.0588V14.9432L45.5853 0.411675Z"
                            fill="#58DBDF"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_3594_29031">
                            <rect width="48" height="48" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FidusDifference;
